import { render, staticRenderFns } from "./DetailsLogement.vue?vue&type=template&id=8d6b5b16&scoped=true"
import script from "./DetailsLogement.vue?vue&type=script&lang=js"
export * from "./DetailsLogement.vue?vue&type=script&lang=js"
import style0 from "./DetailsLogement.vue?vue&type=style&index=0&id=8d6b5b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6b5b16",
  null
  
)

export default component.exports